import React from 'react';
import { LuTriangleAlert, LuCheck, LuClock } from 'react-icons/lu';
import { MdDoNotDisturbAlt } from 'react-icons/md';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import '../../../theme/timeLine.css';
import { TimelineStageColor } from '../../../common/pokCore/validation/enums';

import { Stage } from './TimeLine';

interface TimelineStagesProps {
  stages: Stage[];
  stageClicked: (stage: Stage) => void;
}

const renderBadge = (color: Stage['color']) => {
  if (color === TimelineStageColor.Red) {
    return (
      <div className="timeline-badge timeline-badge-error">
        <LuTriangleAlert className="timeline-badge-icon" />
      </div>
    );
  }
  if (color === TimelineStageColor.Teal) {
    return (
      <div className="timeline-badge timeline-badge-success">
        <LuCheck className="timeline-badge-icon" />
      </div>
    );
  }
  if (color === TimelineStageColor.Blue) {
    return (
      <div className="timeline-badge timeline-badge-info">
        <LuClock className="timeline-badge-icon" />
      </div>
    );
  }
  if (color === TimelineStageColor.Gray) {
    return (
      <div className="timeline-badge timeline-badge-na">
        <MdDoNotDisturbAlt className="timeline-badge-icon" />
      </div>
    );
  }
  return null;
};

export const TimelineStages: React.FC<TimelineStagesProps> = ({
  stages,
  stageClicked,
}) => {
  return (
    <div className="w-100 d-flex justify-content-center">
      <div className="timeline-stages-container">
        {/* Connecting lines as background */}
        <div className="timeline-lines">
          {stages.map(
            (stage, index) =>
              index < stages.length - 1 && (
                <div
                  key={`line-${index}`}
                  className="flex-fill d-flex align-items-center"
                >
                  <div
                    className={`timeline-line timeline-line-${stage.color}`}
                  />
                </div>
              ),
          )}
        </div>

        {stages.map((stage, index) => {
          const Icon = stage.icon;
          return (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events
            <div
              role="button"
              tabIndex={0}
              key={index}
              className="timeline-stage"
              onClick={() =>
                stage.color !== TimelineStageColor.Gray
                  ? stageClicked(stage)
                  : null
              }
            >
              <div className="position-relative">
                <OverlayTrigger
                  overlay={
                    stage.tooltip ? <Tooltip>{stage.tooltip}</Tooltip> : <></>
                  }
                >
                  <div
                    className={`timeline-circle timeline-circle-${stage.color}`}
                  >
                    <Icon
                      className={`timeline-icon timeline-icon-${stage.color}`}
                    />
                  </div>
                </OverlayTrigger>
                {renderBadge(stage.color)}
              </div>
              <div className="timeline-label-container">
                <p className={`timeline-label timeline-label-${stage.color}`}>
                  {stage.label}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
